import { tss } from "tss-react/mui";

export const useContactFormStyles = tss.withName("ContactForm").create(({ theme }) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(5),
        border: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(3),
        },
    },
    fields: {
        display: "flex",
        flexDirection: "column" as const,
        gap: theme.spacing(3),
    },
    submitBtn: {
        marginTop: theme.spacing(1),
    },
    successAlert: {
        borderRadius: 2,
    },
    errorAlert: {
        borderRadius: 2,
    },
}));
